import { useEffect } from "react";
import { useParams, useLocation } from "wouter";

/**
 * Redirect component for /asset/:id to /asset/:id/overview
 * Preserves query parameters from the original URL
 * @returns {null}
 */
export default function AssetRedirect() {
  const { id } = useParams();
  const [, setLocation] = useLocation();

  useEffect(() => {
    // Encode the id to handle special characters in asset numbers
    const encodedId = encodeURIComponent(id);
    // Preserve query parameters
    const queryString = window.location.search;
    setLocation(`/asset/${encodedId}/overview${queryString}`, {
      replace: true,
    });
  }, [id, setLocation]);

  return null;
}
